import { get } from 'lodash';
import { isStandardHubCluster } from '../../utils/helpers';

// eslint-disable-next-line import/prefer-default-export
export function getEnabledNotifications(hub) {
  const evendDrivenNotificaitons = get(hub, 'settings.evendDrivenNotificaiton');
  return evendDrivenNotificaitons || [];
}
